import React from 'react';
import PropTypes from 'prop-types';
import Chip from '@mui/material/Chip';

import { VpHoverInfo } from '@vp-ui/components';

const statusToDetailsMapper = {
  completed: {
    text: 'Completed',
    color: 'success',
    info: 'Captions have been generated successfully. You can now watch the video with captions or download the VTT/SRT files.'
  },
  processing: {
    text: 'Processing',
    color: 'warning',
    info: 'We are generating captions for your video. This usually takes 1-3 minutes. Please check back shortly!'
  },
  pending: {
    text: 'Pending',
    color: 'info',
    info: 'Caption generation is queued and will start shortly.'
  },
  failed: {
    text: 'Failed',
    color: 'error',
    info: 'Caption generation failed. Please try again or contact support if the issue persists.'
  }
};

export const VpCaptionBadge = ({ status = 'pending' }) => {
  const badgeDetails = statusToDetailsMapper[status] || statusToDetailsMapper.pending;

  return (
    <VpHoverInfo label={badgeDetails?.info}>
      <Chip color={badgeDetails?.color} label={badgeDetails?.text} size="small" />
    </VpHoverInfo>
  );
};

VpCaptionBadge.propTypes = {
  status: PropTypes.string
};

export default VpCaptionBadge;



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpCaptionBadge/VpCaptionBadge.jsx